__turbopack_context__.v({
  "button": "Button-module-scss-module__vhn1ba__button",
  "disabled": "Button-module-scss-module__vhn1ba__disabled",
});
